import { Casette as o } from "./casette.js";
import { MusicBox as r } from "./music-box.js";
import { Headphone as m } from "./headphone.js";
import { Microphone2 as t } from "./microphone-2.js";
import { Banjo as i } from "./banjo.js";
import { Guitar as p } from "./guitar.js";
import { Trumpet as f } from "./trumpet.js";
import { Sound as e } from "./sound.js";
import { Education as a } from "./education.js";
import { Microphone as n } from "./microphone.js";
import { Megaphone as s } from "./megaphone.js";
import { Equalizer as l } from "./equalizer.js";
import { Speaker as c } from "./speaker.js";
import { Help as h } from "./help.js";
import { Target as u } from "./target.js";
import { TargetArrow as R } from "./target-arrow.js";
import { Speed as d } from "./speed.js";
import { Membership as x } from "./membership.js";
import { Birdhouse as B } from "./birdhouse.js";
import { Vr as M } from "./vr.js";
import { RobotMini as b } from "./robot-mini.js";
import { ToyHorse as g } from "./toy-horse.js";
import { Drone as C } from "./drone.js";
import { Acting as G } from "./acting.js";
import { Skull as P } from "./skull.js";
import { Party as S } from "./party.js";
import { Rainbow as y } from "./rainbow.js";
import { Anchor as k } from "./anchor.js";
import { Trophy as A } from "./trophy.js";
import { Calculator as H } from "./calculator.js";
import { Puzzle as T } from "./puzzle.js";
import { Photos as z } from "./photos.js";
import { Abacus as E } from "./abacus.js";
import { Glasses as L } from "./glasses.js";
import { RocketLaunch as j } from "./rocket-launch.js";
import { BallSoccer as w } from "./ball-soccer.js";
import { BallBeach as D } from "./ball-beach.js";
import { BallBasketball as I } from "./ball-basketball.js";
import { Lenses as K } from "./lenses.js";
import { Resolution as q } from "./resolution.js";
import { Camera as v } from "./camera.js";
import { FrameRate as F } from "./frame-rate.js";
import { Codec as O } from "./codec.js";
import { Chair as V } from "./chair.js";
import { Membercard as _ } from "./membercard.js";
import { Console as J } from "./console.js";
import { InnovationHeroes as N } from "./innovation-heroes.js";
import { Magnet as Q } from "./magnet.js";
import { Poscast as U } from "./poscast.js";
import { OfficeChair as W } from "./office-chair.js";
import { Image as X } from "./image.js";
import { StarSky as Y } from "./star-sky.js";
import { _2Angle as Z } from "./2-angle.js";
import { Boombox as $ } from "./boombox.js";
import { Djset as oo } from "./djset.js";
import { Earpods as ro } from "./earpods.js";
import { GettoBlaster as mo } from "./getto-blaster.js";
import { Gramophone as to } from "./gramophone.js";
import { Headphones as io } from "./headphones.js";
import { KeyGroup as po } from "./key-group.js";
import { KeyGroupRefresh as fo } from "./key-group-refresh.js";
import { PaintRoller as eo } from "./paint-roller.js";
import { Podcast as ao } from "./podcast.js";
import { Ratio16x9 as no } from "./ratio-16x9.js";
import { Ratio1x1 as so } from "./ratio-1x1.js";
import { Ratio2x5 as lo } from "./ratio-2x5.js";
import { Ratio3x4 as co } from "./ratio-3x4.js";
import { Ratio4x3 as ho } from "./ratio-4x3.js";
import { Ratio5x2 as uo } from "./ratio-5x2.js";
import { Ratio9x16 as Ro } from "./ratio-9x16.js";
import { GrammaPhone as xo } from "./gramma-phone.js";
const wr = {
  Casette: o,
  MusicBox: r,
  Headphone: m,
  Microphone2: t,
  Banjo: i,
  Guitar: p,
  Trumpet: f,
  Sound: e,
  Education: a,
  Microphone: n,
  Megaphone: s,
  Equalizer: l,
  Speaker: c,
  Help: h,
  Target: u,
  TargetArrow: R,
  Speed: d,
  Membership: x,
  Birdhouse: B,
  Vr: M,
  RobotMini: b,
  ToyHorse: g,
  Drone: C,
  Acting: G,
  Skull: P,
  Party: S,
  Rainbow: y,
  Anchor: k,
  Trophy: A,
  Calculator: H,
  Puzzle: T,
  Photos: z,
  Abacus: E,
  Glasses: L,
  RocketLaunch: j,
  BallSoccer: w,
  BallBeach: D,
  BallBasketball: I,
  Lenses: K,
  Resolution: q,
  Camera: v,
  FrameRate: F,
  Codec: O,
  Chair: V,
  Membercard: _,
  Console: J,
  InnovationHeroes: N,
  Magnet: Q,
  Poscast: U,
  OfficeChair: W,
  Image: X,
  StarSky: Y,
  _2Angle: Z,
  Boombox: $,
  Djset: oo,
  Earpods: ro,
  GettoBlaster: mo,
  Gramophone: to,
  Headphones: io,
  KeyGroup: po,
  KeyGroupRefresh: fo,
  PaintRoller: eo,
  Podcast: ao,
  Ratio16x9: no,
  Ratio1x1: so,
  Ratio2x5: lo,
  Ratio3x4: co,
  Ratio4x3: ho,
  Ratio5x2: uo,
  Ratio9x16: Ro,
  GrammaPhone: xo
};
export {
  wr as Leisure
};
